import { CardTag as AntdCardTag } from "@empglabs/backoffice-ui-kit"

const CardTag = props => {
  return <AntdCardTag {...props} />
}

export default CardTag
